import VendorCompanyCredit from 'data/vendorCompanyCredit';
import Address from 'data/Address';

export default interface VendorCompany {
  id: number;
  vendorId: number;
  ofmpCompanyId: string;
  vendorCompanyId: string;
  creditInfo: CreditInfo;
  companyName: string;
  address: Pick<Address, 'addressLine1' | 'addressLine2' | 'town' | 'region' | 'countryIsoCode' | 'postalCode'>;
  accountClassification: string;
  activeIndicator: boolean;
  vendorCompanyCredits: VendorCompanyCredit[];
  creditId?: string;
  creditDetails?: CreditDetails;
};

export interface CompanyMDMDetails {
  apigeeId: string;
  name: string;
  address: string;
  accountType: string;
  creditData: string;
  idStatus: string;
}

export interface CreditInfo {
  totalCreditLimit: number;
  availableCreditLimit: number;
  utilization: number;
  isReadOnly: boolean;
  lastUpdated?: string;
  companyMdmDetails?: CompanyMDMDetails;
};

export interface CreditDetails {
  allowNegativeBalance: boolean;
  amount: number;
  availableAmount: number;
  buyerExternalCode: string;
  creditId: string;
  reservedAmount: number;
  sellerCode: string;
  source: string;
  usedAmount: number;
  companyMdmDetails: CompanyMdmDetails;
}
export interface CompanyMdmDetails {
  accountType: string;
  address: string;
  apigeeId: string;
  creditData: string;
  idStatus: string;
  name: number;
}

export type VendorCompanyInfo = Pick<
  VendorCompany,
  'companyName' | 'address' | 'accountClassification' | 'activeIndicator' | 'creditId' | 'vendorCompanyId' | 'id'
> & { hasCredit: boolean };

export const emptyVendorCompanyInfo: VendorCompanyInfo = {
  companyName: '',
  address: {
    addressLine1: '',
    addressLine2: '',
    town: '',
    region: '',
    countryIsoCode: 'US',
    postalCode: '',
  },
  accountClassification: '',
  activeIndicator: false,
  hasCredit: false,
  vendorCompanyId: '',
  id: 0
};

export const emptyCreditInfo: CreditInfo = {
  totalCreditLimit: 0,
  availableCreditLimit: 0,
  utilization: 0,
  isReadOnly: false
};


export interface VendorCompanyDetailsCredit {
  creditId?: string;
  vendorCompanyId: string;
  id: number;
  address: Pick<Address, 'addressLine1' | 'addressLine2' | 'town' | 'region' | 'countryIsoCode' | 'postalCode'>;
}

export const emptyVendorCompanyInfoDetails: VendorCompanyDetailsCredit = {
  creditId: '',
  vendorCompanyId: '',
  id: 0,
  address: {
    addressLine1: '',
    addressLine2: '',
    town: '',
    region: '',
    countryIsoCode: '',
    postalCode: '',
  }
};
